export { default as AdSlider } from './AdSlider'
export { default as AdBanner } from './AdBanner'
export { WrapperSlider } from './wrapperSlider'
export { DoubleSlider } from './doubleSlider'
export { default as SliderContainer } from './SliderContainer'
export { default as ConexxeBanner } from './ConexxeBanner'



// WEBPACK FOOTER //
// ./src/features/Slider/index.js